// Import React.
import React from "react";



// Create the basket SVG icon.
const BasketIcon = () => {

    // Render the basket icon.
    return (

        // Draw the icon using an accessible decorative SVG.
        <svg
            viewBox="0 0 48 48"
            aria-hidden="true"
        >

            {/* Draw the basket handle. */}
            <path d="M14 18L20 8M34 18L28 8" />

            {/* Draw the shopping basket. */}
            <path d="M8 18H40L36 38H12L8 18Z" />

            {/* Draw the first basket detail. */}
            <path d="M18 24V32" />

            {/* Draw the second basket detail. */}
            <path d="M30 24V32" />

        </svg>

    );

};



// Create the printer SVG icon.
const ProductIcon = () => {

    // Render the printer icon.
    return (

        // Draw the T-shirt icon.
        <svg
            viewBox="0 0 48 48"
            aria-hidden="true"
        >

            {/* Draw the complete T-shirt shape. */}
            <path d="M16 8L8 12L5 20L12 23V40H36V23L43 20L40 12L32 8C31 12 28 14 24 14C20 14 17 12 16 8Z" />

        </svg>
        
    );

};



// Create the tracking SVG icon.
const TrackingIcon = () => {

    // Render the tracking icon.
    return (

        // Draw the icon.
        <svg
            viewBox="0 0 48 48"
            aria-hidden="true"
        >

            {/* Draw the globe. */}
            <circle
                cx="24"
                cy="24"
                r="16"
            />

            {/* Draw a vertical globe line. */}
            <path d="M24 8C18 14 18 34 24 40" />

            {/* Draw the opposite vertical globe line. */}
            <path d="M24 8C30 14 30 34 24 40" />

            {/* Draw the globe centre line. */}
            <path d="M8 24H40" />

        </svg>

    );

};



// Create the payment SVG icon.
const PaymentIcon = () => {

    // Render the payment icon.
    return (

        // Draw the icon.
        <svg
            viewBox="0 0 48 48"
            aria-hidden="true"
        >

            {/* Draw the wallet. */}
            <path d="M8 14H36V38H8V14Z" />

            {/* Draw the wallet closure. */}
            <path d="M28 22H40V32H28C25 32 23 30 23 27C23 24 25 22 28 22Z" />

            {/* Draw the wallet button. */}
            <circle
                cx="29"
                cy="27"
                r="1.5"
            />

        </svg>

    );

};



// Create the support SVG icon.
const SupportIcon = () => {

    // Render the support icon.
    return (

        // Draw the icon.
        <svg
            viewBox="0 0 48 48"
            aria-hidden="true"
        >

            {/* Draw the headset. */}
            <path d="M10 27V22C10 14 16 8 24 8C32 8 38 14 38 22V27" />

            {/* Draw the left earpiece. */}
            <path d="M10 24H16V34H10V24Z" />

            {/* Draw the right earpiece. */}
            <path d="M32 24H38V34H32V24Z" />

            {/* Draw the microphone arm. */}
            <path d="M38 32C38 38 34 40 28 40" />

        </svg>

    );

};



// Create the shield SVG icon.
const ShieldIcon = () => {

    // Render the shield icon.
    return (

        // Draw the icon.
        <svg
            viewBox="0 0 48 48"
            aria-hidden="true"
        >

            {/* Draw the shield. */}
            <path d="M24 6L38 12V23C38 32 32 39 24 42C16 39 10 32 10 23V12L24 6Z" />

            {/* Draw the confirmation tick. */}
            <path d="M17 24L22 29L31 19" />

        </svg>

    );

};



// Map API icon names onto local icon components.
const processIcons = {

    // Map basket steps.
    basket: BasketIcon,

    // Map fulfilment steps.
    //printer: PrinterIcon,

    // Map fulfilment steps.
    product: ProductIcon,

    // Map delivery tracking steps.
    tracking: TrackingIcon,

    // Map payment steps.
    payment: PaymentIcon,

    // Map customer support steps.
    support: SupportIcon,

    // Map completed-order steps.
    shield: ShieldIcon,

};



// Export the sale process section.
export const SaleProcess = ({
    saleProcess,
}) => {

    // Get the available process steps.
    const processSteps = saleProcess?.steps ?? [];



    // Render the sales process.
    return (

        // Render the outer process section.
        <section
            className="sale-process"
            aria-labelledby="sale-process-title"
        >

            {/* Keep the process content within the page width. */}
            <div className="sale-process__inner">

                {/* Render the section heading. */}
                <h2
                    className="sale-process__title"
                    id="sale-process-title"
                >
                    {saleProcess?.title}
                </h2>

                {/* Render the supporting introduction. */}
                <p className="sale-process__subtitle">
                    {saleProcess?.subtitle}
                </p>

                {/* Render the process steps. */}
                <ol className="sale-process__steps">

                    {/* Loop through every API-provided process step. */}
                    {processSteps.map((step, stepIndex) => {

                        // Find the SVG component matching this step.
                        const ProcessIcon =
                            processIcons[step?.icon] ?? ShieldIcon;



                        // Render the process step.
                        return (

                            // Render the individual process item.
                            <li
                                className="sale-process__step"
                                key={step?.id ?? stepIndex}
                            >

                                {/* Render the step number. */}
                                <span className="sale-process__number">
                                    {stepIndex + 1}
                                </span>

                                {/* Render the icon container. */}
                                <div className="sale-process__icon">

                                    {/* Render the matching SVG icon. */}
                                    <ProcessIcon />

                                </div>

                                {/* Render the step heading. */}
                                <h3 className="sale-process__step-title">
                                    {step?.title}
                                </h3>

                                {/* Render the step explanation. */}
                                <p className="sale-process__description">
                                    {step?.description}
                                </p>

                            </li>

                        );

                    })}

                </ol>

                {/* Display the additional selling points when supplied. */}
                {saleProcess?.benefits?.length > 0 && (

                    // Create the additional benefits section.
                    <div className="sale-process__benefits">

                        {/* Create the benefits heading area. */}
                        <div className="sale-process__benefits-header">

                            {/* Display the benefits heading. */}
                            <h3 className="sale-process__benefits-title">

                                {/* Display the API-provided heading. */}
                                {saleProcess?.benefitsTitle}

                            </h3>

                            {/* Display the benefits introduction when supplied. */}
                            {saleProcess?.benefitsSubtitle && (

                                // Create the benefits introduction.
                                <p className="sale-process__benefits-subtitle">

                                    {/* Display the API-provided introduction. */}
                                    {saleProcess?.benefitsSubtitle}

                                </p>

                            )}

                        </div>



                        {/* Create the additional benefits list. */}
                        <ul className="sale-process__benefits-list">

                            {/* Loop through each additional benefit. */}
                            {saleProcess.benefits.map((benefit, benefitIndex) => {

                                // Render the individual benefit.
                                return (

                                    // Create the benefit list item.
                                    <li
                                        className="sale-process__benefit"
                                        key={benefit?.id ?? benefitIndex}
                                    >

                                        {/* Display the benefit heading. */}
                                        <h4 className="sale-process__benefit-title">

                                            {/* Display the heading text. */}
                                            {benefit?.title}

                                        </h4>

                                        {/* Display the benefit explanation. */}
                                        <p className="sale-process__benefit-description">

                                            {/* Display the description text. */}
                                            {benefit?.description}

                                        </p>

                                    </li>

                                );

                            })}

                        </ul>

                    </div>

                )}

            </div>

        </section>

    );

};